import { APIgetReportingData } from "../api/target.ts";
import moment from "moment";
import axios from "axios";
import store from "../core/redux/store.jsx";
import { setTargetsAchivement } from "../core/redux/action.jsx";

let eachHourPerc = [5, 10, 11, 13, 15, 14, 12, 10, 6, 3, 1];
import {
  // format,
  startOfWeek,
  endOfWeek,
  // startOfYesterday,
  endOfYesterday,
  startOfMonth,
  endOfMonth,
  // startOfYear,
  // endOfYear,
  addYears,
  addDays,
  // addWeeks,
  // addMonths,
  // differenceInDays,
  // getDay,
} from "date-fns";
let tL = {
  // "sls": "sales",
  // "pb": "passerby",
  // "trn": "transactions",
  // "trf": "traffic",
  // "in": "trafficin",
  // "out": "trafficout",
  // "sh": "staffhours",
  // "is": "totalitemsold",
  // "dw": "storedwelltime",
};
async function fetchSingleKpi(params) {
  let freq = params.startDate == params.endDate ? "hourly" : "daily";
  params.frequency = freq;
  let resp1 = {};
  resp1 = await APIgetReportingData(params,'');
  if(!resp1)
  {
    return { res: null };
  }

  resp1 = resp1?.response;
  formatV2Resp(resp1, freq == "daily" ? "date" : "hour");
  return { res: resp1 };
}
function formatV2Resp(obj, dT) {
  obj?.kpis?.forEach((itm) => {
    adjustDateId(itm, dT);
  });
  obj?.compare?.forEach((itm) => {
    adjustDateId(itm, dT);
  });
}
function adjustDateId(itm, dT) {
  let dO = typeof itm?._id === "string" ? itm?._id?.split("_") : itm;
  itm._id = {
    storeCode: dO && dO[1],
  };

  dO = dO && dO[0];
  dO = dO && dO?.split("");
  if (dT == "date") {
    dO && dO.splice(6, 0, "-");
    dO && dO.splice(4, 0, "-");
  }
  let newD = dO && dO.join("");

  itm._id[dT] = newD;
  Object.keys(itm).forEach((k) => {
    if (tL[k]) {
      itm[tL[k]] = itm[k];
      delete itm[k];
    }
  });
}
// check value arrives of all stores
let allStores = [];
store.subscribe(() => {
  const { stores } = store.getState();
  const { stores: storeObj } = stores;
  const { stores: allStoresO } = storeObj;
  allStores = allStoresO;
});
// check value arrives of all stores
export const fetchDataTarget = async (payload) => {
  // return async () => {
  if (payload.trackLatest) {
    // commit('setTracker', payload.trackLatest);
  }
  // var week = rootState?.user?.startWeek;
  var week = 0;
  const weekStart = week == "MONDAY" ? 1 : 0;
  var dt = new Date();
  var dtoday = new Date();
  payload.startDate = moment(addDays(startOfMonth(dt), -5)).format(
    "YYYY-MM-DD"
  );
  payload.todayDate = moment(dtoday).format("YYYY-MM-DD");
  payload.endDate = moment(addDays(endOfMonth(dtoday), 5)).format("YYYY-MM-DD");
  let cDate = addYears(new Date(), -1);
  let cSt = moment(addDays(startOfMonth(cDate), -5)).format("YYYY-MM-DD");
  let cEt = moment(addDays(endOfMonth(cDate), 5)).format("YYYY-MM-DD");
  // let days = rootState.filter.filter.daysOfWeek;
  let days = payload.days;
  
  const params = {
    client_id: payload.client_id,
    client_secret: payload.client_secret,
    startDate: payload.startDate,
    endDate: payload.endDate,
    compareStartDate: cSt,
    compareEndDate: cEt,
    kpiTypes: payload.kpiTypes,
    storeCodes: payload.storeCodes,
    frequency: payload.frequency,
    days,
  }
  let res = await fetchSingleKpi(params);
  if(!res?.res?.kpis)
      return [];

  let storesWithTarget = { kpis: {}, compare: {}, keys: {} };
  res.res.kpis.forEach((kpi) => {
    if (kpi.st) {
      storesWithTarget.kpis[kpi._id.storeCode] =
        (storesWithTarget.kpis[kpi._id.storeCode] || 0) + kpi.st;
    }
  });
  res?.res?.compare.forEach((kpi) => {
    if (kpi.st) {
      storesWithTarget.compare[kpi._id.storeCode] =
        (storesWithTarget.compare[kpi._id.storeCode] || 0) + kpi.st;
    }
  });
  storesWithTarget.keys["kpis"] = Object.keys(storesWithTarget.kpis);
  storesWithTarget.keys["compare"] = Object.keys(
    storesWithTarget.compare
  );
  tenantPatterns = await getPattern();

  // if(payload.trackLatest) {
  // if(rootState.target.callTracker[payload.trackLatest.callerId] !== payload.trackLatest.value) {
  //   return false;
  // }
  // }

  var sumCalc = (arr, bool) => {
    var key = bool ? "sls" : "st";
    return arr.reduce(
      (accumulator, currentValue) => accumulator + currentValue[key],
      0
    );
  };
  function hasTarget() {
    var d = new Date();
    var startMonth = moment(startOfMonth(d)).format("YYYY-MM-DD");
    var endMonth = moment(endOfMonth(d)).format("YYYY-MM-DD");
    var targetSales = res.res.kpis.filter(
      (v) =>
        new Date(startMonth).getTime() <= new Date(v._id.date).getTime() &&
        !(new Date(endMonth).getTime() < new Date(v._id.date).getTime())
    );
    return sumCalc(targetSales, false) > 0;
  }
  let userHasTarget = hasTarget();
  let userTodaysExpect = 0;

  function getTargetSalesData(stD, enD, isPrev, type) {
    let targetSales;
    let sTime = new Date(stD).getTime();
    let eTime = new Date(enD).getTime();
    if (isPrev) {
      if (type == 1) {
        //PREVIOUS_YEAR_SAME_DAY_OF_WEEK
        // const diffDays = differenceInDays(
        //   sTime,
        //   eTime
        // );
        sTime = new Date(addDays(new Date(sTime), -364)).getTime();
        eTime = new Date(addDays(new Date(eTime), -364)).getTime();
      } else if (type == 2) {
        sTime = moment(new Date(sTime), "YYYY-MM-DD")
          .subtract(1, "year")
          .valueOf();

        eTime = moment(new Date(eTime), "YYYY-MM-DD")
          .subtract(1, "year")
          .valueOf();
      }
    }

    let kS = !isPrev ? "kpis" : "compare";

    targetSales = res.res[kS].filter((v) => {
      let cTime = new Date(v._id.date).getTime();
      // if(userHasTarget) {
      //   return storesWithTarget.keys[kS].indexOf(v._id.storeCode) > -1 && sTime <=  cTime && cTime <= eTime
      // } else {
      return sTime <= cTime && cTime <= eTime;
      // }
    });
    return JSON.parse(JSON.stringify(targetSales));
  }

  function getTargetAchieved(ts1, ts2, ts3, tTar = 0) {
    let ss = sumCalc(ts1, true);
    let ts = sumCalc(ts2, !userHasTarget);
    let tsE = sumCalc(ts3, !userHasTarget);

    return {
      achieved: ss,
      expectedTar: tsE + tTar,
      expectedTargetFormatted:
        "¥" + Math.floor(tsE + tTar).toLocaleString() || "0",
      achievedFormatted: "¥" + ss.toLocaleString() || "0",
      target: ts,
      targetFormatted: "¥" + ts.toLocaleString() || "0",
      userHasTarget,
    };
  }

  function getTodayCurrentTarget(ts1, ts2) {
    let today = new Date()
      .toLocaleDateString("en", { weekday: "long" })
      .toLowerCase();

    let selStores = payload.storeCodes;
    let companyID = "A9Lqp7y4MWifcwHn9";
    // let companyID = JSON.parse(localStorage.getItem("vuex"))?.user?.profile
    // ?.tenant?.intercom?.companyId;
    let o = 0;
    let e = 0;
    let c = 0;
    selStores.forEach((s) => {
      let timing = allStores
        ?.filter((ss) => ss.storeCode == s)[0]
        ?.storeTimings?.filter((t) => t.day == today)[0];
      if (timing) {
        c++;
        o += Number(timing.openingTime?.split(":")[0]);
        e += Number(timing.closingTime?.split(":")[0]);
      }
    });

    if (c == 0) {
      o = 10;
      e = 19;
    } else {
      o /= c;
      e /= c;
    }
    o = Math.floor(o);
    e = Math.ceil(e);
    var tZ = new Date().getTimezoneOffset() * 60 * 1000;
    var currTime = new Date(Date.now() + tZ + 9 * 60 * 60 * 1000);
    let currH = currTime.getHours();

    let hourPerc;

    let pF = false;
    if (tenantPatterns.data[companyID]?.ja) {
      pF = true;
      hourPerc = tenantPatterns.data[companyID].ja;
    } else {
      hourPerc = tenantPatterns.data["default_0"]?.ja;
    }

    if (!hourPerc) {
      hourPerc = eachHourPerc;
    } else {
      hourPerc = hourPerc?.split(",").map((a) => Number(a));
    }
    let expTar = 0;
    let ts = sumCalc(ts2, !userHasTarget);

    if (!pF) {
      let dV = 12;
      let hV = e - o + 1;

      let diff = dV - hV;
      if (diff > 0) {
        let sss = 0;
        for (let i = hV; i < dV; i++) {
          sss += hourPerc[i];
          hourPerc[i] = 0;
        }
        let dss = sss / hV;
        for (let i = 0; i < hV; i++) {
          hourPerc[i] += dss;
        }
      } else if (diff < 0) {
        for (let i = 0; i < Math.abs(diff); i++) {
          hourPerc.push(0);
        }
      }
    }
    for (let i = o; i <= currH; i++) {
      expTar += (ts * hourPerc[i - o]) / 100;
    }

    return expTar;
  }

  var getDailySales = () => {
    let ts1 = getTargetSalesData(
      payload.todayDate,
      payload.todayDate,
      false,
      1
    );
    let ts2 = getTargetSalesData(
      payload.todayDate,
      payload.todayDate,
      !userHasTarget,
      1
    );
    userTodaysExpect = getTodayCurrentTarget(ts1, ts2);
    return getTargetAchieved(ts1, ts2, [], userTodaysExpect);
  };
  // //
  var getWeeklySales = () => {
    var d = new Date();
    let st = moment(startOfWeek(d, { weekStartsOn: weekStart })).format(
      "YYYY-MM-DD"
    );
    let et = moment(endOfWeek(d, { weekStartsOn: weekStart })).format(
      "YYYY-MM-DD"
    );
    const yesterday = endOfYesterday();
    let ts1 = getTargetSalesData(st, et, false, 1);
    let ts2 = getTargetSalesData(st, et, !userHasTarget, 1);
    let ts3 = getTargetSalesData(st, yesterday, !userHasTarget, 1);

    return getTargetAchieved(ts1, ts2, ts3, userTodaysExpect);
  };
  // //
  var getMonthlySales = () => {
    var d = new Date();
    let st = moment(startOfMonth(d)).format("YYYY-MM-DD");
    let et = moment(endOfMonth(d)).format("YYYY-MM-DD");
    const yesterday = endOfYesterday();
    let ts1 = getTargetSalesData(st, et, false, 2);
    let ts2 = getTargetSalesData(st, et, !userHasTarget, 2);
    let ts3 = getTargetSalesData(st, yesterday, !userHasTarget, 2);
    return getTargetAchieved(ts1, ts2, ts3, userTodaysExpect);
  };
  //
  const setData = {
    targets: {
      dailyTarget: {
        remainingFormatted: "0",
        remaining: "0",
        // ...rootState.target.targets.dailyTarget,
        ...getDailySales(),
      }, // dailyTarget
      weeklyTarget: {
        remainingFormatted: "0",
        remaining: "0",
        // ...rootState.target.targets.weeklyTarget,
        ...getWeeklySales(),
      }, // dailyTarget
      monthlyTarget: {
        remainingFormatted: "0",
        remaining: "0",
        // ...rootState.target.targets.monthlyTarget,
        ...getMonthlySales(),
      }, // monthlyTarget
      isPreviousData: !userHasTarget,
    },
  };

  store.dispatch(setTargetsAchivement(setData.targets));

  return res?res:null;
  // };
};
let tenantPatterns = null;
async function getPattern() {
  if (tenantPatterns) {
    return tenantPatterns;
  }
  let resp = await axios.get(
    "https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/localization/tenant_sales_pattern.json",
    {
      headers: {
        Authorization: "",
      },
    }
  );

  return resp;
}
